import { Link } from 'react-router-dom';

const reasons = [
  { icon: 'ri-medal-fill', title: 'ICPI Certified Specialists', desc: 'Certified by the Interlocking Concrete Pavement Institute — industry gold standard for paver installation.' },
  { icon: 'ri-palette-line', title: 'High-End Design Approach', desc: 'We bring a refined design sensibility to every project. Nothing cookie-cutter, everything custom.' },
  { icon: 'ri-building-4-line', title: 'Durable, Long-Lasting Builds', desc: 'Premium materials + proper base prep = installations that look great and last decades.' },
  { icon: 'ri-chat-check-line', title: 'Clear Communication', desc: "You're kept in the loop at every stage — no surprises, no delays, no confusion from start to finish." },
  { icon: 'ri-calendar-check-line', title: 'On Time & On Budget', desc: 'We respect your time and investment — every project delivered as promised.' },
  { icon: 'ri-home-smile-line', title: 'Residential & Commercial', desc: 'From backyard patios to commercial hardscaping — we scale to any project size and complexity.' },
];

const stats = [
  { value: '500+', label: 'Projects Completed' },
  { value: '10+', label: 'Years Experience' },
  { value: '5.0★', label: 'Average Rating' },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-parkside-darker overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Image side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://www.parksidepavers.com/files/projects/16/images/thumb/thumb_large_IMG%5F2840%2Ejpg"
                alt="Premium paver driveway installation by Parkside Pavers Tampa Bay"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-parkside-darker/60 to-transparent" />
            </div>
            {/* Floating stats card */}
            <div className="absolute bottom-6 left-4 right-4 bg-white/10 backdrop-blur-md rounded-2xl p-5 grid grid-cols-3 gap-4 border border-white/15">
              {stats.map((stat, i) => (
                <div key={stat.label} className={`text-center ${i > 0 ? 'border-l border-white/20' : ''}`}>
                  <p className="font-display text-2xl text-parkside-gold">{stat.value}</p>
                  <p className="text-white/60 text-[11px] font-semibold mt-0.5 leading-tight">{stat.label}</p>
                </div>
              ))}
            </div>
            {/* Floating accent badge */}
            <div className="absolute -top-4 -right-4 bg-parkside-amber text-white rounded-2xl px-5 py-3 transform rotate-3">
              <p className="font-bold text-sm leading-tight">ICPI</p>
              <p className="text-white/80 text-[10px] font-semibold uppercase tracking-wider">Certified</p>
            </div>
          </div>

          {/* Content side */}
          <div className="order-1 lg:order-2">
            <span className="inline-block bg-parkside-amber/20 text-parkside-gold text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4">
              Why Parkside
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-white mb-8 tracking-display leading-tight">
              Why Homeowners Choose Parkside Pavers
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
              {reasons.map((r) => (
                <div key={r.title} className="flex gap-3.5 group">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/8 border border-white/12 rounded-xl flex-shrink-0 mt-0.5 group-hover:bg-parkside-amber/20 transition-colors">
                    <i className={`${r.icon} text-parkside-gold text-lg`} />
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">{r.title}</p>
                    <p className="text-white/50 text-xs mt-1 leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/contact"
                className="bg-parkside-amber text-white font-bold px-7 py-3.5 rounded-xl hover:bg-parkside-amber/90 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Get Your Free Estimate
                <span className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
              <a
                href="tel:813-404-6313"
                className="border border-white/25 text-white font-semibold px-7 py-3.5 rounded-xl hover:bg-white/10 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </span>
                (813) 404-6313
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
